"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.messagingExtensionTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.messagingExtensionTemplates = [
    {
        id: "message-extension-with-api-from-scratch-ts",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratch,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-js",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratch,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratch,
        language: "csharp",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-api-key-ts",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingApiKey,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-api-key-js",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingApiKey,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-api-key-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingApiKey,
        language: "csharp",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-sso-ts",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingOAuth,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-sso-js",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingOAuth,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-with-api-from-scratch-sso-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingOAuth,
        language: "csharp",
        description: "",
    },
    {
        id: "m365-message-extension-ts",
        name: templateNames_1.TemplateNames.MessageExtensionM365,
        language: "typescript",
        description: "",
    },
    {
        id: "m365-message-extension-js",
        name: templateNames_1.TemplateNames.MessageExtensionM365,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-action-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionAction,
        language: "csharp",
        description: "",
    },
    {
        id: "message-extension-action-ts",
        name: templateNames_1.TemplateNames.MessageExtensionAction,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-action-js",
        name: templateNames_1.TemplateNames.MessageExtensionAction,
        language: "javascript",
        description: "",
    },
    {
        id: "link-unfurling-ts",
        name: templateNames_1.TemplateNames.LinkUnfurling,
        language: "typescript",
        description: "",
    },
    {
        id: "link-unfurling-js",
        name: templateNames_1.TemplateNames.LinkUnfurling,
        language: "javascript",
        description: "",
    },
    {
        id: "link-unfurling-csharp",
        name: templateNames_1.TemplateNames.LinkUnfurling,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=me.js.map